var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEnglish(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3313_2450",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 17
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 16.5C12.4183 16.5 16 12.9183 16 8.5C16 4.08172 12.4183 0.5 8 0.5C3.58172 0.5 0 4.08172 0 8.5C0 12.9183 3.58172 16.5 8 16.5Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3313_2450)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0.5L0.25 1.1875L0 1.90625V2.625L1 4.3125L0 6V7L1 8.5L0 10V11L1 12.6875L0 14.375V16.5L0.6875 16.25L1.40625 16.5H2.125L3.8125 15.5L5.5 16.5H6.5L8 15.5L9.5 16.5H10.5L12.1875 15.5L13.875 16.5H16L15.75 15.8125L16 15.0938V14.375L15 12.6875L16 11V10L15 8.5L16 7V6L15 4.3125L16 2.625V0.5L15.3125 0.75L14.5938 0.5H13.875L12.1875 1.5L10.5 0.5H9.5L8 1.5L6.5 0.5H5.5L3.8125 1.5L2.125 0.5H0Z",
    fill: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5 0.5V3.875L13.875 0.5H10.5ZM16 2.625L12.625 6H16V2.625ZM0 6H3.375L0 2.625V6ZM2.125 0.5L5.5 3.875V0.5H2.125ZM5.5 16.5V13.125L2.125 16.5H5.5ZM0 14.375L3.375 11H0V14.375ZM16 11H12.625L16 14.375V11ZM13.875 16.5L10.5 13.125V16.5H13.875Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0.5V1.90625L4.09375 6H5.5L0 0.5ZM6.5 0.5V7H0V10H6.5V16.5H9.5V10H16V7H9.5V0.5H6.5ZM14.5938 0.5L10.5 4.59375V6L16 0.5H14.5938ZM5.5 11L0 16.5H1.40625L5.5 12.4062V11ZM10.5 11L16 16.5V15.0938L11.9062 11H10.5Z",
    fill: "#D80027"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnglish);
export default __webpack_public_path__ + "static/media/english.14d7a1d481468dee123e0576219be251.svg";
export { ForwardRef as ReactComponent };